var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33337C4.32466 1.33337 1.33398 4.32405 1.33398 8.00008C1.33398 11.6761 4.32466 14.6667 8.00065 14.6667C11.6766 14.6667 14.6673 11.6761 14.6673 8.00004C14.6673 4.32401 11.6766 1.33337 8.00065 1.33337ZM8.00065 13.5451C4.94313 13.5451 2.45563 11.0576 2.45563 8.00008C2.45563 4.94256 4.94313 2.45502 8.00065 2.45502C11.0582 2.45502 13.5457 4.94252 13.5457 8.00008C13.5457 11.0576 11.0582 13.5451 8.00065 13.5451Z",
    fill: "#312E36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00043 3.83643C6.67016 3.83643 5.58789 4.9187 5.58789 6.24897C5.58789 6.55869 5.83899 6.80979 6.14871 6.80979C6.45843 6.80979 6.70953 6.55869 6.70953 6.24897C6.70953 5.53717 7.28864 4.95807 8.00043 4.95807C8.71222 4.95807 9.29133 5.53717 9.29133 6.24897C9.29133 6.96076 8.71222 7.53986 8.00043 7.53986C7.69071 7.53986 7.43961 7.79096 7.43961 8.10069V9.3687C7.43961 9.67842 7.69071 9.92952 8.00043 9.92952C8.31015 9.92952 8.56125 9.67842 8.56125 9.3687V8.5957C9.62199 8.34225 10.413 7.3862 10.413 6.24893C10.413 4.9187 9.3307 3.83643 8.00043 3.83643Z",
    fill: "#312E36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 12.06C8.43356 12.06 8.78507 11.7085 8.78507 11.2749C8.78507 10.8413 8.43356 10.4897 7.99996 10.4897C7.56635 10.4897 7.21484 10.8413 7.21484 11.2749C7.21484 11.7085 7.56635 12.06 7.99996 12.06Z",
    fill: "#312E36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(1.33398 1.33337)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.27a5268533c248320e10ac8a2cecae01.svg";
export { ForwardRef as ReactComponent };